import { dayCalendarClasses } from "@mui/x-date-pickers/DateCalendar";
import { pickerDayClasses } from "@mui/x-date-pickers/PickerDay";

export const DAY_SIZE = "24px";

export const STYLES = {
  width: 240,
  height: "unset",
  ".MuiYearCalendar-root, .MuiMonthCalendar-root": {
    width: "auto",
    columnGap: "2px",
    rowGap: "5px",
  },
  [`.${pickerDayClasses.root}`]: {
    "--PickerDay-size": DAY_SIZE,
  },
  [`.${dayCalendarClasses.weekDayLabel}`]: {
    width: DAY_SIZE,
  },
  [`.${dayCalendarClasses.slideTransition}`]: {
    minHeight: 160,
  },
  ".MuiDateCalendar-viewTransitionContainer.MuiPickersFadeTransitionGroup-root": {
    height: 200,
  },
};

export const UNSELECTED_DAY_STYLES = {
  [`.${pickerDayClasses.root}.${pickerDayClasses.selected}`]: {
    background: "none",
    color: "inherit",
  },
  [`.${pickerDayClasses.today}`]: {
    background: "none",
    border: "1px solid",
    borderColor: "neutral.main",
  },
};

export const VIEWS = ["year", "month", "day"] as const;
export const MIN_DATE = new Date(2020, 0, 1);
export const MAX_DATE = new Date();
